import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * EvacuationLayout — full-screen, no admin chrome (no Sidebar / NotificationBell / TrialBanner).
 * Used by /evacuation/active and /evacuation/warden/:token.
 * Prominent red header banner so it's unmistakable in a real emergency.
 */
export default function EvacuationLayout({ children, eventLabel }) {
  return (
    <div
      className="min-h-screen bg-navy-900 text-white flex flex-col"
      data-testid="evacuation-layout"
    >
      <header
        className="bg-red-600 text-white px-4 py-3 sticky top-0 z-40 shadow-lg"
        data-testid="evacuation-header"
      >
        <div className="max-w-5xl mx-auto flex items-center gap-3">
          <AlertTriangle className="w-6 h-6 animate-pulse" />
          <div className="flex-1">
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-80">
              EntryBook · Fire register
            </div>
            <div className="text-base font-bold leading-tight">
              EVACUATION ACTIVE{eventLabel ? ` · ${eventLabel}` : ""}
            </div>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-5xl mx-auto w-full p-4 md:p-6">
        {children}
      </main>
    </div>
  );
}
